import closeCurrentModal from '../../../actions/close-current-modal';
import { getIsPublishing } from '../../../selectors/is-loading-selectors';

export default function onDismissModal() {
  return (dispatch, getState) => {
    if (!getIsPublishing(getState())) {
      return dispatch(closeCurrentModal());
    }
  };
}
